import React from 'react';
export function Men() {
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-505">
      <div className="max-w-[1800px] mx-auto" data-id="element-506">
        <header className="mb-20 text-center" data-id="element-507">
          <span className="text-[10px] font-display uppercase tracking-[0.5em] mb-4 block text-black/40" data-id="element-508">
            Masculine Authority
          </span>
          <h1 className="text-4xl md:text-6xl font-display font-bold tracking-[0.2em] uppercase mb-6" data-id="element-509">
            Men
          </h1>
          <p className="max-w-xl mx-auto text-sm font-light tracking-widest text-black/60 leading-relaxed uppercase" data-id="element-510">
            Tailored Agbadas and modern sets for the contemporary gentleman.
          </p>
        </header>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-511">
          {['https://cdn.magicpatterns.com/uploads/24GiQwrwzepMESJJTXz3Q3/image.png', 'https://cdn.magicpatterns.com/uploads/bxTL7vVABPe8YuDE1LiVeu/image.png'].map((img, i) => <div key={i} className="group cursor-pointer" data-id="element-512">
              <div className="aspect-[4/5] bg-grey-divider overflow-hidden mb-6" data-id="element-513">
                <img src={img} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" alt="Menswear" data-id="element-514" />
              </div>
              <h3 className="text-[11px] font-display font-bold tracking-widest uppercase" data-id="element-515">
                Menswear Look {i + 1}
              </h3>
            </div>)}
        </div>
      </div>
    </div>;
}